define([
    'underscore',
    'backbone',
    'backbone-stickit',
], function(_, Backbone, Stickit) {
    // adds backbone-stickit mixin to Backbone View
    _.extend(Backbone.View.prototype, Stickit.ViewMixin);

    var ViewOriginal = Backbone.View;
    Backbone.View = function(options) {
        this.options = options;
        ViewOriginal.apply(this, arguments); 
    };
    Backbone.View.prototype = ViewOriginal.prototype;
    Backbone.View.extend = ViewOriginal.extend;
    return Backbone; 
});
